module.exports = __webpack_public_path__ + "images/emoji/small_red_triangle.615816eab9742e82e468.png";